import { Component } from '@angular/core';
import {environment} from "../../../environments/environment";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-rag-flow-page',
  standalone: true,
  imports: [],
  templateUrl: './rag-flow-page.component.html',
  styleUrl: './rag-flow-page.component.css'
})
export class RagFlowPageComponent {
  safeUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ragFLowServiceUrl);
  }
  protected readonly environment = environment;
}
